import { useRef, useEffect, useState} from "react";
import { PhaserGame } from "./PhaserGame";
import { EventBus } from "./game/EventBus";

function App() {
    const phaserRef = useRef();
    const [sceneReady, setSceneReady] = useState(false);

    useEffect(() => {
        EventBus.on('current-scene-ready', (scene) => {
            if (phaserRef.current) {
                phaserRef.current.scene = scene;
                setSceneReady(true);
            }
        });

        return () => {
            EventBus.removeListener('current-scene-ready');
        };
    }, []);

    const startGame = () => {
        console.log("React: startGame() clicked");

        const scene = phaserRef.current?.scene;

        if (scene && typeof scene.startGame === "function") {
            console.log("React: calling scene.startGame()");
            scene.startGame();
        } else {
            console.warn("Scene not ready or startGame missing.");
        }
    };

return (
    <div id="app" style={{ textAlign: "center" }}>
        {sceneReady && (
            <div style={{ marginBottom: "10px" }}>
                <h2 style={{
                    color: "#fff",
                    fontFamily: "Comic Sans MS",
                    margin: 0,
                    fontSize: "20px"
                }}>
                    Use A and D  or the arrows to move the helicopters. Catch the asteroids!
                </h2>
            </div>
        )}

        <PhaserGame ref={phaserRef} />

        {sceneReady && (
            <div style={{ marginTop: "20px" }}>
                <button
                    className="button"
                    onClick={startGame}
                    style={{
                        padding: "10px 25px",
                        fontSize: "18px",
                        color: "#ffffffff",
                        backgroundColor: "#2600ffff",
                        border: "none",
                        borderRadius: "10px",
                        cursor: "pointer",
                        fontFamily: "Comic Sans MS"
                    }}
                >
                    Save The World!
                </button>
            </div>
        )}
    </div>
);

}

export default App;
